import { useEffect, useState } from 'react';
import { Loader2, Receipt } from 'lucide-react';
import ModalShell from '../../components/ui/ModalShell';
import UctenkaHtml from '../../components/UctenkaHtml';

/**
 * Náhled účtenky (GET /uctenka). Jen zobrazení — rozvozce ji ukáže
 * zákazníkovi, modal se zavře přes X / backdrop.
 *
 * Kreslí ji šablona OS (`html`), stejná jako tisk, stránka objednávky
 * i PDF (účtenka 2026-10-20) — dřív tu byla vlastní verze bez DIČ,
 * platby a bodů, zaokrouhlená na koruny.
 */
/** `url` — jiný zdroj než zastávka vlastní dávky (přehled rozvozů: náhled bez čísla dokladu). */
export default function UctenkaModal({ zastavka, url = null, onClose, isDark }) {
    const [html, setHtml] = useState(null);
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState(null);
    const [sirka, setSirka] = useState(() => Math.min(360, (typeof window !== 'undefined' ? window.innerWidth : 400) - 48));

    useEffect(() => {
        const zmer = () => setSirka(Math.min(360, window.innerWidth - 48));
        window.addEventListener('resize', zmer);
        return () => window.removeEventListener('resize', zmer);
    }, []);

    useEffect(() => {
        if (!zastavka) return;
        setLoading(true);
        fetch(url ?? `/api/rozvoz/zastavky/${zastavka.objednavka_id}/uctenka`, { credentials: 'same-origin' })
            .then(r => r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`)))
            .then(j => setHtml(j.html ?? null))
            .catch(e => setErr(e?.message || String(e)))
            .finally(() => setLoading(false));
    }, [zastavka, url]);

    if (!zastavka) return null;

    return (
        <ModalShell open onClose={onClose} isDark={isDark} nadpis="Účtenka" ikona={Receipt} barva="#FF8A00">
            <div style={{ padding: 16, display: 'flex', justifyContent: 'center' }}>
                {loading && (
                    <div style={{ textAlign: 'center', padding: 24, color: 'var(--text-secondary)' }}>
                        <Loader2 size={20} className="animate-spin" style={{ display: 'inline-block', color: '#FF8A00' }} />
                    </div>
                )}
                {!loading && html && <UctenkaHtml html={html} sirka={360} zobrazit={sirka} />}
                {!loading && err && (
                    <div style={{ fontSize: 13, fontWeight: 700, color: '#EF4444' }}>Účtenka se nenačetla: {err}</div>
                )}
            </div>
        </ModalShell>
    );
}
